import React from "react";
import "./question.css";
import "rsuite/dist/styles/rsuite-default.css";
import { connect } from "react-redux";
import AnswerChip from "./Answers/AnswerChip";
import EmojiAnswer from "./Answers/EmojiAnswer";
import TextAnswer from "./Answers/TextAnswer";
import Comments from "./Answers/Comments";
import FileTypeAnswer from "./Answers/FileTypeAnswer";
import SignatureAnswer from "./Answers/SignatureAnswer";
import StarRatingAnswer from "./Answers/StarRatingAnswer";
import GridAnswer from "./Answers/GridAnswer";
import GridSpotHistoryAnswer from "./Answers/GridSpotHistoryAnswer";
import { editAnswer, clearEditAnswer } from "../../../../redux/survey/actions";
import EditIcon from "./Answers/EditIcon";

function SingleAnswer({
  answer,
  survey_theme,
  allQuestions,
  answeres,
  editAnswer_,
  clearEditAnswer_,
  edit_answer,
}) {
  const OnEditAnswer = () => {
    clearEditAnswer_();
    // Finding the index of the current question in the array of all questions
    let currentQuestionIndex = undefined;
    for (let index = 0; index < allQuestions?.length; index++) {
      const element = allQuestions[index]._id === answer?.question?._id;
      if (element) {
        currentQuestionIndex = index;
      }
    }
    if (currentQuestionIndex !== undefined) {
      editAnswer_({ question: currentQuestionIndex });
    }
  };
  const isEditingThisGridspot =
    answer?.type === "gridspot" &&
    edit_answer &&
    Object.keys(edit_answer).length &&
    allQuestions[edit_answer?.question]?._id === answer?.question?._id;

  const OnEditImage = (image, index) => {
    clearEditAnswer_();
    // Finding the index of the current question in the array of all questions
    let currentQuestionIndex = undefined;
    for (let index = 0; index < allQuestions?.length; index++) {
      const element = allQuestions[index]._id === answer?.question?._id;
      if (element) {
        currentQuestionIndex = index;
      }
    }
    if (currentQuestionIndex !== undefined) {
      editAnswer_({
        question: currentQuestionIndex,
        image: image,
        index: index,
      });
    }
  };
  return (
    <>
      {/* Render answer based on its type */}
      {answer ? (
        <div className="flex flex-column items-end justify-start pl-0 transition-all duration-200 mt-3 text-right">
          {/* Render emoji answer */}
          {answer?.type === "emoji" ? (
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <EmojiAnswer answer={answer} answeres={answeres} />
            </div>
          ) : answer?.type === "file" ? (
            // Render file answer
            <div className="answerArea">
              <FileTypeAnswer
                files={answeres[answer?.question?._id]?.value}
                type={answer?.type}
                survey_theme={survey_theme}
                onEdit={(image, index) => OnEditImage(image, index)}
              />
            </div>
          ) : answer?.type === "sequence" ? (
            <div className="answerArea d-flex justify-end align-items-center">
              {/* Render sequence chips */}
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              {answeres[answer?.question?._id]?.value?.map((text, i) => (
                <AnswerChip
                  label={
                    answer?.question?.options?.find((opt) => opt?._id === text)
                      ?.text || ""
                  }
                  key={i}
                />
              ))}
            </div>
          ) : answer?.type === "star_rating" ? (
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <StarRatingAnswer answer={answer} answeres={answeres} />
            </div>
          ) : answer?.type === "gridspot" ? (
            !isEditingThisGridspot ? (
              <div className="d-flex justify-end align-items-start">
                <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
                <GridSpotHistoryAnswer answer={answer} answeres={answeres} />
              </div>
            ) : null
          ) : ["multiselect", "skills"]?.includes(answer?.type) ? (
            <div className="answerArea">
              <div className="d-flex justify-end align-items-start mb-2">
                <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              </div>
              <div
                className="d-flex flex-wrap justify-end align-items-center"
                style={{ gap: "4px" }}
              >
                {answeres[answer?.question?._id]?.value?.map((text, i) => (
                  <AnswerChip
                    label={
                      answer?.question?.options?.find(
                        (opt) => opt?._id === text,
                      )?.text || ""
                    }
                    key={i}
                  />
                ))}
              </div>
            </div>
          ) : ["radio", "employees", "dropdown"]?.includes(answer?.type) ? (
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <AnswerChip
                label={
                  answer?.question?.options?.find(
                    (opt) =>
                      opt?._id === answeres[answer?.question?._id]?.value,
                  )?.text || ""
                }
                selectedAns={answeres[answer?.question?._id]?.value}
                type={answer?.type}
              />
            </div>
          ) : answer?.type === "grid" ? (
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <GridAnswer answer={answer} answeres={answeres} />
            </div>
          ) : answer?.type === "handwrittenInput" ? (
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <SignatureAnswer answer={answer} answeres={answeres} />
            </div>
          ) : ["rating"]?.includes(answer?.type) ? (
            // Render rating answer
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <TextAnswer
                text={
                  answer?.question?.options?.find(
                    (opt) =>
                      opt?._id === answeres[answer?.question?._id]?.value,
                  )?.text || ""
                }
              />
            </div>
          ) : ["inventory"]?.includes(answer?.type) ? (
            // Render rating answer
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <TextAnswer
                text={answer?.text}
                selectedAns={answeres[answer?.question?._id]?.value}
                type={answer?.type}
              />
            </div>
          ) : (
            // Render text answer
            <div className="d-flex justify-end align-items-center">
              <EditIcon onClick={OnEditAnswer} survey_theme={survey_theme} />
              <TextAnswer text={answeres[answer?.question?._id]?.value} />
            </div>
          )}
          {/* Render comments */}
          {answeres[answer?.question?._id]?.write_in ? (
            <Comments comment={answeres[answer?.question?._id]?.write_in} />
          ) : (
            ""
          )}
          {answer?.question?._id in answeres ? (
            // Render additional comments if available
            answeres[answer?.question?._id]?.note ? (
              <Comments comment={answeres[answer?.question?._id]?.note} />
            ) : (
              ""
            )
          ) : null}
          {answer?.question?._id in answeres ? (
            answeres[answer?.question?._id]?.image?.length ? (
              <FileTypeAnswer files={answeres[answer?.question?._id]?.image} />
            ) : (
              ""
            )
          ) : null}
        </div>
      ) : null}
    </>
  );
}
// mapStateToProps function to map Redux state to component props
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
    edit_answer: state.survey.edit_answer,
  };
};
// Redux mapping function to map dispatch to props
const mapDispatchToProps = (dispatch) => {
  return {
    editAnswer_: (data) => dispatch(editAnswer(data)),
    clearEditAnswer_: () => dispatch(clearEditAnswer()),
  };
};
// Connect SingleAnswer component to Redux store
export default connect(mapStateToProps, mapDispatchToProps)(SingleAnswer);
